import { Autocomplete, Chip, FormControl, ListItem, Stack, TextField, useTheme } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { getReccurssiveObjectKeys } from '../../utils';

export const SelectTag = ({
  name,
  menus,
  formControlSX,
  sx,
  onChange,
  disabled,
  allowClear,
  defaultValue = '',
  ...props
}) => {
  const { control } = useFormContext();
  const theme = useTheme();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, formState: { errors } }) => (
        <>
          <FormControl fullWidth sx={formControlSX}>
            <Stack spacing={1}>
              <Autocomplete
                sx={{
                  '& .MuiAutocomplete-inputRoot': { p: 0.5, borderColor: 'error' }
                }}
                {...field}
                onChange={(event, value) => {
                  if (onChange && typeof onChange === 'function') {
                    onChange(value ? { target: { value: value._id, name: value.name, row: value } } : '');
                  }

                  field.onChange(value ? value._id : '');
                }}
                value={(menus && menus.find((option) => option._id === field.value)) || null}
                options={menus || []}
                disabled={disabled}
                disableClearable={!allowClear}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      ...sx,
                      '& .MuiInputBase-input': { px: 1, py: '4px !important', fontSize: '1.2rem', fontWeight: 700 },
                      '& .MuiInputBase-input:focus': { backgroundColor: '#E0F7F7' },
                      '& .Mui-disabled': { backgroundColor: '#f0ffff' },
                      ...(!!getReccurssiveObjectKeys(errors, name) && {
                        '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.error.main }
                      })
                    }}
                    {...params}
                    {...props}
                    name={name}
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip key={option._id} label={option.name} {...getTagProps({ index })} />
                  ))
                }
                renderOption={(props, option) => {
                  const isOccupied = option.occupy_status === 'B' || option.occupy_status === 'R';
                  return (
                    <ListItem
                      {...props}
                      style={{
                        ...props.style,
                        fontSize: '1.2rem',
                        fontWeight: 700,
                        backgroundColor: isOccupied ? 'red' : '',
                        color: isOccupied ? 'white' : ''
                      }}
                    >
                      {option.name}
                    </ListItem>
                  );
                }}
              />
            </Stack>
          </FormControl>
        </>
      )}
    />
  );
};
